/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_performance/used_vehicles_show';
import 'stylesheets/showroom_performance/used_vehicles_show';
